module.exports = __webpack_public_path__ + "static/media/angularjs.31fc07ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/skill/angularjs.png
// module id = 102
// module chunks = 0